export const excludeDeactivatedReviews = (productId) => {
  return `target(id="${productId}") and includedInStatistics=true`;
};
